import { REVIEWS_KEY } from './constants';
import { PROFILE_GA_CATEGORY } from '../../constants';
import { EVENT_INITIATORS, INTERACTION_TYPES, TARGETS } from '../../../../EventTrackingConstants';
import { AnalyticsTypes } from '../../../../middleware/google-analytics';

export const ActionTypes = {
    SHOW_MORE_REVIEWS: `${REVIEWS_KEY}/SHOW_MORE_REVIEWS`,
    CLICK_FAQ: `${REVIEWS_KEY}/CLICK_FAQ`,
    CLICK_BACK_TO_TOP: `${REVIEWS_KEY}/CLICK_BACK_TO_TOP`,
    TRACK_CLICK_I_BUBBLE_OVERALL: `${REVIEWS_KEY}/TRACK_CLICK_I_BUBBLE_OVERALL`,
    TRACK_CLICK_I_BUBBLE_WAIT_TIME: `${REVIEWS_KEY}/TRACK_CLICK_I_BUBBLE_WAIT_TIME`,
    TRACK_CLICK_I_BUBBLE_BEDSIDE_MANNER: `${REVIEWS_KEY}/TRACK_CLICK_I_BUBBLE_BEDSIDE_MANNER`,
    TRACK_PROFILE_SCROLL_COUNT: `${REVIEWS_KEY}/TRACK_PROFILE_SCROLL_COUNT`,
};

export const showMoreReviews = () => ({
    type: ActionTypes.SHOW_MORE_REVIEWS,
    meta: {
        analytics: {
            type: AnalyticsTypes.TrackEvent,
            action: 'Click Read More Reviews',
            category: PROFILE_GA_CATEGORY,
            tags: [],
            data: {
                Section: TARGETS.PATIENT_REVIEWS,
                Component: TARGETS.SHOW_MORE_REVIEWS,
                InteractionType: INTERACTION_TYPES.CLICK,
                Element: TARGETS.SHOW_MORE_REVIEWS,
                Initiator: EVENT_INITIATORS.USER,
                EventAction: 'click show more reviews',
            },
        },
    },
});

export const clickFAQ = () => ({
    type: ActionTypes.CLICK_FAQ,
    meta: {
        analytics: {
            type: AnalyticsTypes.TrackEvent,
            action: 'Click Patient Knowledge Base',
            category: PROFILE_GA_CATEGORY,
            tags: [],
            data: {
                Section: TARGETS.PATIENT_REVIEWS,
                Component: TARGETS.PATIENT_KNOWLEDGE_BASE,
                InteractionType: INTERACTION_TYPES.CLICK,
                Element: TARGETS.LINK,
                Initiator: EVENT_INITIATORS.USER,
                EventAction: 'click patient knowledge base',
            },
        },
    },
});

export const clickBackToTop = () => ({
    type: ActionTypes.CLICK_BACK_TO_TOP,
    meta: {
        analytics: {
            type: AnalyticsTypes.TrackEvent,
            action: 'Click Back To Top Of Page',
            category: PROFILE_GA_CATEGORY,
            tags: [],
            data: {
                Section: TARGETS.PATIENT_REVIEWS,
                Component: TARGETS.BACK_TO_TOP_OF_PAGE,
                InteractionType: INTERACTION_TYPES.CLICK,
                Element: TARGETS.LINK,
                Initiator: EVENT_INITIATORS.USER,
                EventAction: 'click back to top of page',
            },
        },
    },
});

export const trackClickIBubbleOverall = () => ({
    type: ActionTypes.TRACK_CLICK_I_BUBBLE_OVERALL,
    meta: {
        analytics: {
            type: AnalyticsTypes.TrackEvent,
            action: 'Click I Bubble Overall',
            category: PROFILE_GA_CATEGORY,
            data: {
                Section: TARGETS.PROFILE,
                Component: TARGETS.I_BUBBLE,
                InteractionType: INTERACTION_TYPES.CLICK,
                Element: TARGETS.I_BUBBLE,
                Initiator: EVENT_INITIATORS.USER,
                EventAction: 'click overall',
            },
        },
    },
});

export const trackClickIBubbleWaitTime = () => ({
    type: ActionTypes.TRACK_CLICK_I_BUBBLE_WAIT_TIME,
    meta: {
        analytics: {
            type: AnalyticsTypes.TrackEvent,
            action: 'Click I Bubble Wait Time',
            category: PROFILE_GA_CATEGORY,
            data: {
                Section: TARGETS.PROFILE,
                Component: TARGETS.I_BUBBLE,
                InteractionType: INTERACTION_TYPES.CLICK,
                Element: TARGETS.I_BUBBLE,
                Initiator: EVENT_INITIATORS.USER,
                EventAction: 'click wait time',
            },
        },
    },
});

export const trackClickIBubbleBedsideManner = () => ({
    type: ActionTypes.TRACK_CLICK_I_BUBBLE_BEDSIDE_MANNER,
    meta: {
        analytics: {
            type: AnalyticsTypes.TrackEvent,
            action: 'Click I Bubble Bedside Manner',
            category: PROFILE_GA_CATEGORY,
            data: {
                Section: TARGETS.PROFILE,
                Component: TARGETS.I_BUBBLE,
                InteractionType: INTERACTION_TYPES.CLICK,
                Element: TARGETS.I_BUBBLE,
                Initiator: EVENT_INITIATORS.USER,
                EventAction: 'click bedside manner',
            },
        },
    },
});

export const trackProfileScrollCount = count => ({
    type: ActionTypes.TRACK_PROFILE_SCROLL_COUNT,
    meta: {
        analytics: {
            type: AnalyticsTypes.TrackEvent,
            action: 'Profile Scroll Count',
            label: count,
            data: {
                Component: TARGETS.PATIENT_REVIEWS,
                Element: TARGETS.PATIENT_REVIEW,
                Initiator: EVENT_INITIATORS.USER,
                InteractionType: INTERACTION_TYPES.SCROLL,
                Section: TARGETS.PROFILE_NAVIGATION_REVIEWS_TAB,
            },
        },
    },
});
